import React from 'react';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
} from '@/bit/components/components.text';
import CustomLink from '@/bit/components/components.custom-link';
import IconGlyph from '@/bit/components/components.icon-glyph';

export const TITLE_SIZE = TEXT_SIZE;
function Tittle({
  text,
  size = TITLE_SIZE.TITLE6,
  action = null,
  step = null,
  cyData,
  boldTitle = true,
}) {
  return (
    <div className="title-container">
      {step && (
        <div
          className={`title-step ${
            step?.checked ? 'title-step--completed' : ''
          }`}
        >
          <TextInfo
            className="action-text"
            text={step?.label}
            color={step?.checked ? TEXT_COLOR.WHITE : TEXT_COLOR.GREY6}
            size={TEXT_SIZE.CAPTION3}
            cyData={`${cyData}__step`}
          />
        </div>
      )}

      <div className="title-text">
        <TextInfo
          className="title-text__text"
          text={text}
          color={TEXT_COLOR.GREY6}
          fontType={
            boldTitle ? TEXT_FONT_WEIGHT.BOLD : TEXT_FONT_WEIGHT.REGULAR
          }
          size={size}
          cyData={cyData}
        />
        {action && (
          <CustomLink
            role="button"
            className="title-action"
            onClick={() => action.onClick()}
            taggingInfo={{
              componentName: 'link',
              componentVariation: 'all',
              componentContent: action.label,
              componentPerso: '',
              componentProduct: '',
            }}
            ariaLabel={action.label}
            cyData={`${cyData}__${action.label}`}
            disabled={action.disabled}
          >
            <IconGlyph
              id="lapiz"
              alt="lapiz"
              kind="m"
              layoutSize={{ width: 13 }}
              color={TEXT_COLOR.BLUEA}
            />
            <TextInfo
              className="title-action__text"
              text={action.label}
              color={TEXT_COLOR.BLUEA}
              size={TEXT_SIZE.CAPTION3}
              cyData={`${cyData}__${action.label}__text`}
            />
          </CustomLink>
        )}
      </div>
      <style jsx>
        {`
          @import '../../styles/colors.scss';
          .title-container {
            margin-bottom: 8px;
            position: relative;
            display: flex;
            align-items: center;
            .title-text {
              display: flex;
              align-items: center;
            }
            :global(.title-text__text) {
              margin-right: 8px;
            }
            .title-step {
              position: relative;
              right: 0px;
              top: 0px;
              width: 32px;
              height: 32px;
              border: 1px solid $color-gp--grey6;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 8px;
            }
            .title-step--completed {
              background-color: $color-gp--grey6;
            }
            :global(.title-action) {
              display: flex;
              flex-direction: row;
              align-items: center;
            }
            :global(.title-action__text) {
              padding-left: 4px;
            }
          }
        `}
      </style>
    </div>
  );
}

export default Tittle;
